import React from 'react';
import { Store } from 'react-notifications-component';
import { NotificationContent } from '../components';

export const getCommonNotificationActions = (prefix, addNotification, successCallback = null) => {
  return {
    onSuccess: () => {
      addNotification('success', `${prefix} successfully`, 'Success', 3000);
      successCallback && successCallback();
    },
    onError: (message) => addNotification('danger', message, 'Error', 3000),
  };
};

export function addNotification(type, text, title, time = 3000, customProps) {
  const notificationId = Store.addNotification({
    content: <NotificationContent type={type} title={title} text={text} customProps={customProps} />,
    message: text,
    type: type,
    insert: 'top',
    container: 'top-right',
    timingFunction: 'ease-out',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
      pauseOnHover: true,
      touch: false,
      onScreen: true,
      duration: time,
      showIcon: true,
    },
    onRemoval: (id) => Store.removeNotification(id),
  });

  if (time) setTimeout(() => Store.removeNotification(notificationId), time);

  return notificationId;
}

export const removeNotification = id => Store.removeNotification(id);
